export const ACCOUNT_TYPES = {
  NORMAL_USER: "NORMAL_USER",
  SYSTEM_ADMIN: "SYSTEM_ADMIN",
  LOCAL_GOVERNMENT: "LOCAL_GOVERNMENT",
  VIP_MEMBER: "VIP_MEMBER",
  LAND_VALUATION_OFFICER: "LAND_VALUATION_OFFICER"
};

export const AccountTypesOptions = [
  {
    label: "Quản trị hệ thống",
    value: ACCOUNT_TYPES.SYSTEM_ADMIN
  },
  {
    label: "Thành viên cao cấp",
    value: ACCOUNT_TYPES.VIP_MEMBER
  },
  {
    label: "Chính quyền địa phương",
    value: ACCOUNT_TYPES.LOCAL_GOVERNMENT
  },
  {
    label: " Cán bộ định giá đất",
    value: ACCOUNT_TYPES.LAND_VALUATION_OFFICER
  },
  {
    label: "Tài khoản thường",
    value: ACCOUNT_TYPES.NORMAL_USER
  },
];
